import React, { useEffect, useMemo } from "react";
import MiniTableProCore from "./MiniTableProCore";

/**
 * Print / display-only version. No edit UI, no dialogs.
 * Used for PDF and final display. Sorted by _sortingOrder from props.
 */
function MiniTableProPrint(props) {
  const { miniTableProperties = [], ...rest } = props;

  useEffect(() => {
    require("./style.scss");
  }, []);

  const sortedByOrder = useMemo(
    () =>
      [...(miniTableProperties || [])].sort(
        (a, b) => (Number(a._sortingOrder) ?? 0) - (Number(b._sortingOrder) ?? 0)
      ),
    [miniTableProperties]
  );

  return (
    <MiniTableProCore
      {...rest}
      miniTableProperties={sortedByOrder}
      printVersion={true}
    />
  );
}

export default MiniTableProPrint;
